module.exports = __webpack_public_path__ + "static/logo_finanziato_dallunione_europea_pnrr-82505cb6badd31b2b84654b49977269d.png";